import FeedbackPage from '@/components/FeedbackPage'

export default function PicturingFeedbackPage() {
  return (
    <FeedbackPage emoji="🔮" title="pages.onboarding.picturingFeedback.title" />
  )
}
